(function( app, videoGroupForm, $, undefined ) {
  'use strict';

  const autocompleteEndpoints = {
    'videos': '/admin/api/v1/videos'
  }
  const formElements = {
    'videos_selector': '.video_id_input'
  }

  // Public Method
  videoGroupForm.initForm = function() {
    _initVideoSelections()

    // Bound once, on ActiveAdmin's post-insert event, so the new fieldset is already in
    // the DOM. Binding inside _initVideoSelections would re-bind on every add, doubling
    // the handlers each time.
    $(document).on('has_many_add:after', '.has_many_container', _initVideoSelections)
  }

  // The select carries `default-select`, which makes activeadmin_addons skip it, so this
  // is the only Select2 instance on the element -- no stacked duplicate to undo.
  function _initVideoSelections() {
    $(formElements['videos_selector']).select2({
      placeholder: 'Select Video ...',
      allowClear: false,
      minimumInputLength: 3,
      ajax: {
        url: autocompleteEndpoints['videos'],
        dataType: 'json',
        data: function (params) {
          var query = {
            search: params.term
          }
          // Query parameters will be ?search=[term]
          return query;
        },
        processResults: function (data) {
          return {
            results: data
          };
        }
      }
    })
  }
}(window.app ||= {},
  window.app.videoGroupForm ||= {},
  jQuery
));

(function ($) {
  $(function() {
    // INIT the Video Group - New/Edit Page
    if ($('#new_video_group').length || $('#edit_video_group').length) {
      app.videoGroupForm.initForm();
    }
  })
})(jQuery);
